module.exports = __webpack_public_path__ + "img/uppage.cd31dd09.png";